import { render, staticRenderFns } from "./ListManufacture.vue?vue&type=template&id=10a5a2d1&"
import script from "./ListManufacture.vue?vue&type=script&lang=js&"
export * from "./ListManufacture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports